module.exports = __webpack_public_path__ + "img/chat.99dfb5a5.png";